import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

export default class {
  constructor(el) {
    this.el = el;
    this.blockId = el.getAttribute('data-block-id')
  }

  init() {
    this.CardCarousel();
  }

  CardCarousel() {
    this.slider = new Swiper(this.el.querySelector(`.swiper${this.blockId}`), {
      slidesPerView: 'auto',
      autoHeight: true,
      spaceBetween: 30,
      speed: 600,
      direction: 'horizontal',
      pagination: {
        el: `.swiper-pagination${this.blockId}`,
        clickable: true,
      },
      navigation: {
        nextEl: `.swiper-next-${this.blockId}`,
        prevEl: `.swiper-previous-${this.blockId}`
      }
    })
  }
}
